<script setup>
import { onMounted, computed, ref } from "vue";
import { useThrottleScroll } from "@/utils/useThrottleScroll";
import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useRoute } from "vue-router";
import { isOIS } from "@/utils/functions";
import TheFooter from "@/components/sections/TheFooter.vue";
import TheMainScreen from "@/components/sections/TheMainScreen.vue";
import Loader from "@/components/ui/Loader.vue";
import BaseCookies from "@/components/blocks/BaseCookies.vue";
import { register } from "swiper/element/bundle";
register();

const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const route = useRoute();

const { throttleScroll } = useThrottleScroll();

const loaderActive = ref(false);

const isServicesPage = computed(() => route.name === "services");

const callback = (entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add("animated");
			observer.unobserve(entry.target);
		}
	});
};

const options = {
	rootMargin: "0px 0px -150px 0px",
	threshold: 0,
};


onMounted(async () => {
	const observer = new IntersectionObserver(callback, options);
	loaderActive.value = true;	

	window.addEventListener("scroll", () => {
		throttleScroll(storeScroll.handleScroll);
	});

	window.addEventListener("load", () => {
		loaderActive.value = false;
	});

	document.querySelectorAll(".section").forEach((item) => {
		observer.observe(item);
	});

	await storeSettings.mainSettings();
	await storeRequests.getCourts();
	await storeRequests.geteQuipments();
	storeRequests.isProductsLoaded = true;
	
});


</script>

<template>
	<div class="wrapper" id="wrapper">
		<TheMainScreen v-if="!isServicesPage" :bg-attachment="isOIS" :page-loaded="loaderActive" />
		<main class="main">
			<RouterView />
		</main>
		<TheFooter v-if="!isServicesPage" />
		<Loader v-if="loaderActive" />
		<BaseCookies />
	</div>
</template>

<style scoped></style>
@/stores/storeSettings @/stores/storeScroll
